(function($) {
    $(function() {
        $('.js-form-submit').on('click', function(e) {
            e.preventDefault();

            const theForm = $('.js-login-form');
            const formData = theForm.serializeArray();

            $.ajax({
                url: '/api/oauth2/token',
                type: 'POST',
                data: {
                    username: formData[0].value,
                    password: formData[1].value,
                    grant_type: 'password',
                },
                dataType: 'json',
                error: function(error) {
                    console.log(error);
                    return;
                },
                success: function(response) {
                    if (response.access_token) {
                        Cookies.set('operator_token', response.access_token, '365');
                        Cookies.set('logged_in', true, '365');
                        window.api = API_URL;
                        window.location.href = '/';
                    } else {
                        $('.error-text')
                            .text('Hibás felhasználónév/jelszó!')
                            .css('display', 'block');
                    }
                },
            });
        });

        if (Cookies.get('logged_in')) {
            $('.js-logout, .js-logged-in-fields').removeClass('visible-print');
        }

        $('.js-logout').on('click', function() {
            Cookies.remove('operator_token');
            Cookies.remove('logged_in');
            window.api = PUBLIC_API_URL;
            window.location.href = '/';
        });
    });
})(jQuery);
